import Vue from "vue"
import App from "./app.vue"

Vue.config.productionTip = false

import "@/assets/common/font/font.gothic.css"

const render = async () => {
  window.VUE_APP = new Vue({
    el: "#app",
    render: (h) => h(App)
  })
}

render()
